import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";
import analytics from "web/script/analytics/analytics";
import userProfiler from "web/script/modules/userprofiler";
import globals from "web/script/modules/globals";
import { useGetSaveForLaterStatus } from "web/react/hooks/use-save-for-later/use-save-for-later";

function constructHref(href, pageViewID, reason, type, fromUrl) {
  var parsed = new URL(href, globals.window.location);

  if (pageViewID) {
    parsed.searchParams.set("pageViewId", pageViewID);
  }

  if (reason) {
    parsed.searchParams.set("reason", reason);
  }

  if (type) {
    parsed.searchParams.set("type", type);
  }

  if (fromUrl) {
    parsed.searchParams.set("fromUrl", fromUrl);
  }

  return parsed.toString();
}
/**
 * A custom hook for keeping a lead URL up to date with analytics data
 * @param {string} href The lead URL to track
 * @param {string} [reason] Optional lead reason
 * @param {string} [type] Optional lead type
 * @param {string} [fromUrl] Optional origin URL
 * @returns {string} The augmented lead URL
 */


export function useLeadHref(href, reason, type, fromUrl) {
  var _useState = useState(href),
      _useState2 = _slicedToArray(_useState, 2),
      leadHref = _useState2[0],
      setLeadHref = _useState2[1];

  useEffect(function () {
    function updateHref() {
      var pageViewID = analytics.getPageViewId();
      setLeadHref(constructHref(href, pageViewID, reason, type, fromUrl));
    }

    updateHref();
    analytics.on("pageViewIdChanged", updateHref);
    return function cleanup() {
      analytics.off("pageViewIdChanged", updateHref);
    };
  }, [fromUrl, href, reason, type]);
  return leadHref;
}

function LeadLink(_ref) {
  var beforeOnClick = _ref.beforeOnClick,
      afterOnClick = _ref.afterOnClick,
      children = _ref.children,
      className = _ref.className,
      fromUrl = _ref.fromUrl,
      href = _ref.href,
      openInNewTab = _ref.openInNewTab,
      productId = _ref.productId,
      reason = _ref.reason,
      type = _ref.type;

  var _useGetSaveForLaterSt = useGetSaveForLaterStatus(productId),
      _useGetSaveForLaterSt2 = _slicedToArray(_useGetSaveForLaterSt, 1),
      isSavedForLater = _useGetSaveForLaterSt2[0];

  var leadHref = useLeadHref(href, reason, type, fromUrl);
  var trackOnClick = useClickTracker("affiliate", "lead", "save_for_later_buy_on_store", !openInNewTab);

  function onClick(event) {
    if (beforeOnClick) {
      beforeOnClick(processClick, event);
    } else {
      processClick(event);
    }
  } // Generate href for tracked button from the props


  function processClick(event) {
    if (productId) {
      userProfiler.saveClickedLead(productId, reason);
    }

    if (isSavedForLater) {
      trackOnClick(event);
    } else if (openInNewTab) {
      // redirect-to-retailer looks for globals.window.opener which is set to null in ios
      // if we use the normal href and target so we need to trigger open in new tab
      // using window.open instead to get the correct behavior
      event.preventDefault();
      window.open(leadHref, "_blank");
    }

    afterOnClick && afterOnClick(event);
  }

  return React.createElement("a", {
    className: className,
    href: leadHref,
    onClick: onClick,
    target: openInNewTab ? "_blank" : null
  }, children);
}

export default LeadLink;
LeadLink.propTypes = {
  beforeOnClick: PropTypes.func,
  afterOnClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fromUrl: PropTypes.string,
  href: PropTypes.string.isRequired,
  openInNewTab: PropTypes.bool,
  productId: PropTypes.string,
  reason: PropTypes.string,
  type: PropTypes.string
};
LeadLink.defaultProps = {
  openInNewTab: false
};